const emerging = {
    emergingArtists: "Artistas Emergentes",
    artists: "Artistas",
    numberWorks: "Número de Obras",
    artistComments:	"Comentarios del Artista",
}

module.exports = emerging;